// CATEGORY DETECTION
export const getCategory = (title) => {
  const t = title.toLowerCase();

  if (t.includes("industrial")) return "Industrial";
  if (t.includes("commercial")) return "Commercial";
  if (t.includes("consultant") || t.includes("company")) return "Consultant";
  if (t.includes("luxury") || t.includes("home") || t.includes("living")) return "Residential";

  return "Investment";
};


// TAG EXTRACTION (smart)
export const extractTags = (content) => {
  const words = content.toLowerCase();

  const keywords = [
    "ahmedabad",
    "real estate",
    "property",
    "investment",
    "plot",
    "flat",
    "land",
    "location",
    "residential",
    "commercial",
    "industrial"
  ];

  return keywords.filter(k => words.includes(k));
};
